export const SET_PYQ_TESTS_DATA = "SET_PYQ_TESTS_DATA";
export const SET_PYQ_TESTS_RESULT_DATA = "SET_PYQ_TESTS_RESULT_DATA";
export const SET_PYQ_JEE_MAINS_OR_ADVANCED = "SET_PYQ_JEE_MAINS_OR_ADVANCED";
export const SET_PYQ_MAIN_CURRENT_TAB = "SET_PYQ_MAIN_CURRENT_TAB";
export const SET_PYQ_SUB_CURRENT_TAB = "SET_PYQ_SUB_CURRENT_TAB";
export const SET_PYQ_CURRENT_YEAR= "SET_PYQ_CURRENT_YEAR";